import { gql } from '@apollo/client';

export const MY_CLIPPER_RANK_PREVIEW = gql`
  query MyClipperRankPreview {
    myClipperRankPreview {
      views_tier_id
      season_id
      season_name
      season_title_id
    }
  }
`;

export const MY_CLIPPER_RANKS = gql`
  query MyClipperRanks {
    myClipperRanks {
      tracks { id metric current_tier_id unlocked_tier_ids next_threshold }
      season_titles { season_id season_name title_id placement }
    }
  }
`;

export const CLIPPER_RANK_HALL = gql`
  query ClipperRankHall($seasonId: ID, $offset: Int, $limit: Int) {
    clipperRankHall(seasonId: $seasonId, offset: $offset, limit: $limit) {
      season { id name status ends_at entries { rank user_id name avatar_url anonymous title_id views_delta video_count families { id featured_tier_id badges { tier_id season_id season_name } } } }
      clippers { user_id name avatar_url anonymous current_tier_ids lifetime_views video_count families { id featured_tier_id badges { tier_id season_id season_name } } }
      page_info { offset limit total }
    }
  }
`;

export const CLIPPER_RANK_HALL_VIEWER = gql`
  query ClipperRankHallViewer {
    myData { id name profile_picture }
  }
`;

export const ADMIN_CLIPPER_SEASONS = gql`
  query AdminClipperSeasons {
    adminClipperSeasons {
      id documentId name starts_at ends_at timezone status start_snapshotted_at consolidated_at
    }
  }
`;

export const ADMIN_CREATE_CLIPPER_SEASON = gql`
  mutation AdminCreateClipperSeason($name: String!, $starts_at: String!, $ends_at: String!) {
    adminCreateClipperSeason(name: $name, starts_at: $starts_at, ends_at: $ends_at) {
      id documentId name starts_at ends_at timezone status start_snapshotted_at consolidated_at
    }
  }
`;

export const ADMIN_UPDATE_CLIPPER_SEASON = gql`
  mutation AdminUpdateClipperSeason($id: ID!, $name: String, $starts_at: String, $ends_at: String) {
    adminUpdateClipperSeason(id: $id, name: $name, starts_at: $starts_at, ends_at: $ends_at) {
      id documentId name starts_at ends_at timezone status start_snapshotted_at consolidated_at
    }
  }
`;

export const ADMIN_SNAPSHOT_CLIPPER_SEASON_START = gql`
  mutation AdminSnapshotClipperSeasonStart($id: ID!) {
    adminSnapshotClipperSeasonStart(id: $id) {
      id documentId name starts_at ends_at timezone status start_snapshotted_at consolidated_at
    }
  }
`;

export const ADMIN_CONSOLIDATE_CLIPPER_SEASON = gql`
  mutation AdminConsolidateClipperSeason($id: ID!) {
    adminConsolidateClipperSeason(id: $id) {
      id documentId name starts_at ends_at timezone status start_snapshotted_at consolidated_at
    }
  }
`;
